import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { CHECK_WSPOSITIONS } from "./actionTypes";
import { checkWsPositionsSuccess, checkWsPositionsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* checkWsPositions({ payload: { user } }) {
  try {

    const response = yield call(workstationAPI.checkWSPositions, user.token);

    yield put(checkWsPositionsSuccess(response.Positions, response.message));
  } catch (error) {
    yield put(checkWsPositionsError(error));
  }
}

export function* watchCheckWsPositions() {
  yield takeEvery(CHECK_WSPOSITIONS, checkWsPositions);
}

function* checkWsPositionsSaga() {
  yield all([fork(watchCheckWsPositions)]);
}

export default checkWsPositionsSaga;
